import React from 'react';
import SubmissionTemplateEditor from '../components/SubmissionTemplateEditor';

const SubmissionTemplateEditorPage = () => {
  return (
    <div className="submission-template-editor-page">
      <SubmissionTemplateEditor />
    </div>
  );
};

export default SubmissionTemplateEditorPage;
